import styles from '../styles/main.module.css';

const ProductC = () => {
    return (
        <main className={`${styles.main} ${styles.mainJaasWorks}`}>
            {/* <div className={styles.projectImg}>

            </div> */}
            
            <div className={styles.projectDetails}>
                <div className={styles.projectTitle}>
                    <h3 className={styles.projectTitle}>
                        Product C
                    </h3>
                </div>
                <div className={styles.projectDescription}>
                    <p className={styles.projectDescription}>
                        Helping to organise projects and events as set up by companies.
                    </p>
                </div>
                <div className={styles.projectsLink}>
                    <a href="/" className={styles.projectLink}>www.productc.com</a>
                </div>
            </div>

            {/* <svg width="90" height="107" viewBox="0 0 90 107" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_11_173)">
            <path d="M43.8216 59.4767C44.3961 59.1776 45.0797 59.1753 45.6562 59.4703L72.5213 73.2196C73.973 73.9626 73.973 76.0374 72.5213 76.7804L45.6562 90.5297C45.0797 90.8247 44.3961 90.8224 43.8216 90.5233L17.4081 76.774C15.9727 76.0269 15.9727 73.9731 17.4081 73.226L43.8216 59.4767Z" fill="black" fill-opacity="0.01"/>
            </g>
            <path d="M10 25.8032C10 22.2147 11.9229 18.9012 15.0386 17.1208L40.0386 2.83508C43.1129 1.07832 46.8871 1.07832 49.9614 2.83508L74.9614 17.1208C78.0771 18.9012 80 22.2147 80 25.8032V54.1968C80 57.7853 78.0771 61.0988 74.9614 62.8792L49.9614 77.1649C46.8871 78.9217 43.1129 78.9217 40.0386 77.1649L15.0386 62.8792C11.9229 61.0988 10 57.7853 10 54.1968V25.8032Z" fill="#C7C9D9"/>
            <path d="M13.3335 27.4322C13.3335 23.8639 15.235 20.5659 18.3231 18.778L39.9898 6.23411C43.0891 4.43979 46.9113 4.43979 50.0105 6.23411L71.6772 18.778C74.7654 20.5659 76.6668 23.8639 76.6668 27.4322V52.5678C76.6668 56.1362 74.7654 59.4342 71.6772 61.2221L50.0105 73.766C46.9113 75.5603 43.0891 75.5603 39.9898 73.766L18.3231 61.2221C15.235 59.4342 13.3335 56.1362 13.3335 52.5678V27.4322Z" fill="#8F90A6"/>
            <path d="M45 43.1389C45 39.2907 47.2081 35.784 50.6784 34.1209L71.8928 23.9544C74.1054 22.894 76.6667 24.5068 76.6667 26.9604V52.5678C76.6667 56.1361 74.7652 59.4341 71.677 61.222L50.0035 73.7699C47.7812 75.0564 45 73.4529 45 70.8851L45 58.3333L45 43.1389Z" fill="#555770"/>
            <path d="M13.3335 26.9682C13.3335 24.5127 15.8984 22.9 18.1113 23.9641L39.3337 34.1689C42.7974 35.8344 45.0002 39.3377 45.0002 43.1811V69.5624C45.0002 69.5624 45.0274 71.9708 45.5885 72.7814C46.0693 73.4761 46.8422 73.9564 47.5414 74.1064C48.5513 74.3231 49.588 73.9915 49.588 73.9915C46.7515 75.6455 43.2457 75.651 40.404 74.0058L18.3231 61.2221C15.235 59.4342 13.3335 56.1362 13.3335 52.5679V26.9682Z" fill="#28293D"/>
            <defs>
            <filter id="filter0_d_11_173" x="0.331543" y="43.2507" width="89.2783" height="63.4985" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
            <feOffset/>
            <feGaussianBlur stdDeviation="8"/>
            <feColorMatrix type="matrix" values="0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.4 0"/>
            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_11_173"/>
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_11_173" result="shape"/>
            </filter>
            </defs>
            </svg> */}

        </main>
    );
}
 
export default ProductC;